export const SUCCESS = 'success' as const;
export const WARNING = 'warning' as const;
export const INFO = 'info' as const;
export const ERROR = 'error' as const;

export type NotificationSeverity = typeof SUCCESS | typeof WARNING | typeof INFO | typeof ERROR;

export const VALID_SEVERITIES: readonly NotificationSeverity[] = [SUCCESS, WARNING, INFO, ERROR];
